<template>
  <div>
      
    <div>
      <span class="xbed-sub-title">视频列表</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>广告设计</BreadcrumbItem>
        <BreadcrumbItem>视频列表</BreadcrumbItem>
      </Breadcrumb>
    </div>

     <section>
        <Tabs class="tabs">
            <TabPane label="视频列表" name="videolList" ref="videolList">
                <Form @submit.native.prevent="preventSubmit" inline>
                    <FormItem>
                        <Button type="primary" @click="openEditVideoModal">新建视频</Button>
                    </FormItem>
                    <!-- Table-->
                    <Table stripe :loading="videolList.loading" ref="videoTable" :columns="column" :data="videolList.content"></Table>
                    <div style="margin: 10px;overflow: hidden">
                        <Page show-sizer placement="top" :total="listCount" :current="videolList.listPage" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
                    </div>
                </Form>
            </TabPane>
        </Tabs>
    </section>

    <!-- Modal -->
    <Modal v-model="editVideoModal.display" :closable="false" :loading="true" :mask-closable="false"  ref="editVideoModal" width="600">
      <p slot="header">
          <span>{{editVideoModal.id?'编辑视频':'新增视频'}}</span>
      </p>
      <Form @submit.native.prevent="preventSubmit" :model="editVideoModal" ref="editVideoModalForm" :rules="editVideoModal.rules" :label-width="100">
        <FormItem prop="videoTitle" label="视频标题：">
          <Input type="text" :maxlength="30" v-model="editVideoModal.videoTitle"></Input>
        </FormItem>
        <FormItem prop="videoCoverUrl" label="视频封面：">
            <RadioGroup v-model="editVideoModal.videoCoverType">
                <Radio label="0">视频自动获取</Radio>
                <Radio label="1">自定义封面</Radio>
            </RadioGroup>
            <div v-if="editVideoModal.videoCoverType === '1'">
              <img :src="editVideoModal.videoCoverUrl" alt="" style="width:100%">
              <Upload ref="uploadImg" action="//upload.qiniup.com" name="file" :format="['jpg','jpeg','png']" :on-format-error="picFormatError" :data="uploadData.form" :before-upload="beforeUpload" :on-progress="uploadVideoCoverProgress" :on-success="uploadSuccess" :show-upload-list=false>
                <Button type="primary" icon="ios-cloud-upload-outline" :disabled="videoLoading">上传图片</Button>
              </Upload>
              <Progress :percent="editVideoModal.videoCoverUpload"></Progress>
            </div>
        </FormItem>
        <FormItem prop="status" label="状态">
            <RadioGroup v-model="editVideoModal.status">
                <Radio label="1">开启</Radio>
                <Radio label="2">关闭</Radio>
            </RadioGroup>
        </FormItem>
        <FormItem prop="displayTerminalId" label="显示终端">
            <RadioGroup v-model="editVideoModal.displayTerminalId">
                <Radio v-for="item in terminalTypes" :key="item.displayTerminalId" :label="item.displayTerminalId">{{item.displayTerminal}}</Radio>
            </RadioGroup>
        </FormItem>
        <FormItem prop="sort" label="排序"> 
                <InputNumber :min="1" :max="99999999" :step="1" style="width: 240px;" v-model="editVideoModal.sort" />
        </FormItem>
        <FormItem prop="showVideoUrl" label="视频链接" v-if="editVideoModal.id">
                <a :href="editVideoModal.videoUrl" target="_blank">{{editVideoModal.videoUrl}}</a>
        </FormItem>
        <FormItem prop="videoUrl">
              <div style="position:relative;">
                <img :src="editVideoModal.framePictureUrl" alt="" style="width:100%;">
                <span class="duration">{{secondToDate(editVideoModal.videoInfo.duration)}} </span>
              </div>
              <Upload ref="uploadVideo" action="//upload.qiniup.com" name="file" :format="['mp4']" :max-size="512000" :on-format-error="videoFormatError" :data="uploadData.form" :before-upload="beforeVideoUpload" :on-progress="uploadVideoProgress" :on-success="uploadVideoSuccess" :show-upload-list=false>
                  <Button type="primary" icon="ios-cloud-upload-outline" :disabled="videoLoading">上传视频</Button>
              </Upload>
              <Progress :percent="editVideoModal.videoUpload"></Progress>
                
        </FormItem>
      </Form>
      <div slot="footer">
            <Button type="default" ref="cancelModalButton" :loading="false" size="large" @click="cancelModal" :disabled="videoLoading">取消</Button>
            <Button type="primary" ref="okModalButton" :loading="modalOkbuttonLoading" size="large" @click="addModalOk" :disabled="videoLoading">确认</Button>
        </div>
    </Modal>

  </div>
</template>

<script>

import Moment from 'moment'
import Utils from '../../utils'
import API from "../../api";
import axios from "../../../node_modules/axios"
import {STORE_KEY} from "../../constants";

export default {
  async created(){ 
        this.token = Utils.findFromLocalStorage("vue-token");
        this.username = Utils.findFromLocalStorage("vue-username");
        this.env = Utils.findFromLocalStorage("env", "dev");
        this.editVideoModal.user = Utils.getFromStore(STORE_KEY.STORE_KEY_USER_NAME)
        console.info('this.editVideoModal.user--------------',this.editVideoModal.user)
        this.init()
  },
  mounted (){
    this.$Notice.config({
      top: 200
    });
  },
  data(){
    const editVideoModalRules = {
        videoTitle: (rule, value, callback) => {
            this.editVideoModal.videoTitle = this.editVideoModal.videoTitle.trim()
            if (this.editVideoModal.videoTitle.length == 0) {
              return callback(new Error('视频标题不能为空'));
            }

            callback();
          },
          sort: (rule, value, callback) => {
            if (!this.editVideoModal.sort) {
              return callback(new Error('排序不能为空'));
            }

            callback();
          },

    }
    return{
        modalOkbuttonLoading:false,
        query:{
          page:1,
          pageSize:10,
        },
        listCount:0,
        terminalTypes:[],
        videolList:[],
        videoLoading:false,
        editVideoModal:{
            display:false,
            id:'',
            videoTitle:'',
            videoCoverType: '0',
            status:'1',
            displayTerminalId:1,
            sort:1,
            videoCoverUrl:'',
            videoUrl:'',
            framePictureUrl:'',
            videoInfo:{},
            videoUpload:0,
            videoCoverUpload:0,
            rules:{
              videoTitle: [{required: true, trigger: 'blur' ,validator: editVideoModalRules.videoTitle,}],
              sort: [{required: true, trigger: 'change' ,validator: editVideoModalRules.sort,}],
            }
        },
        uploadData: {
          name: "",
          form: {}
        },
        column:[
            {
            title: "ID",
            key: "videoId",
            align: "center",
            width: 80
          },
          {
            title: "视频封面",
            key: "videoCoverUrl",
            align: "center",
            width: 200,
            render: (h, params) => {              
              return h("Img", {
                attrs:{
                  src:params.row.videoCoverUrl || params.row.framePictureUrl || ''
                },
                style: {
                  width: '100px',
                  height: '100px'
                },
              })
            }
          },
          {
            title: "视频标题",
            key: "videoTitle",
            align: "center",
            width: 150
          },
          {
            title: "视频链接",
            key: "videoUrl",
            align: "center",
            width: 300,
            render: (h, params) => {
              const urlText = params.row.videoUrl
              return h("a",{
                attrs:{
                  href:urlText,
                  target:'_blank'
                }
              },urlText);
            },
          },
          {
            title: "创建时间",
            key: "createTime",
            align: "center",
            width: 200,
            render: (h, params) => {
              const row = params.row
              const text = Moment(row.createTime).format('YYYY-MM-DD HH:mm:ss');
              return h("Span",{},text);
            },
          },
          {
            title: "显示终端",
            key: "displayTerminal",
            align: "center",
            width: 150
          },
          {
            title: "排序",
            key: "sort",
            align: "center",
            width: 150
          },
          {
            title: "状态",
            key: "status",
            align: "center",
            width: 150,
            render: (h, params) => {
            const row = params.row;
            const color = row.status === 1 ? "green" : "red";
            const text = row.status === 1 ? "开启" : "关闭";
            return h(
              "Tag",
              {
                props: {
                  type: "dot",
                  color: color
                }
              },
              text
            );
            },
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        // TODO: 打开modal
                        this.openEditVideoModal({
                          id:params.row.videoId,
                          videoTitle:params.row.videoTitle,
                          status:params.row.status + '',
                          displayTerminalId:params.row.displayTerminalId,
                          sort:params.row.sort,
                          videoCoverUrl:params.row.videoCoverUrl,
                          videoUrl:params.row.videoUrl,
                          framePictureUrl:params.row.framePictureUrl || params.row.videoUrl + '?vframe/jpg/offset/1',
                          videoInfo:{
                            duration:params.row.videoLength,
                          },
                          videoUpload:100,
                          videoCoverUpload:!params.row.videoCoverUrl ? 0 : 100,
                        });
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style:{
                      marginLeft:'10px',
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: `确定删除${params.row.videoId} - ${params.row.videoTitle}吗？\n一经确定将无法修改`,
                          okText: "确定删除",
                          cancelText: "取消",
                          onOk: () => {
                            this.delVideo(params.row.videoId)
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ]
    }
  },
  methods:{
      init(){
        this.queryvideoList()
        this.queryVideoTerminalList()
      },
      //分页
      changePage(pageIndex) {
          // this.listPage = pageIndex;
          this.query.page = pageIndex
          this.queryvideoList();
      },
      changePageSize(pageSize){
        this.query.pageSize = pageSize
        this.queryvideoList();
      },
      //视频列表
      async queryvideoList(){
          let repVideoList = (await API.omsAPI[this.env].advert.queryVideoList(
          this.query,
          this.token
        )).data;        
         this.listCount = repVideoList.totalCount 
         this.videolList = repVideoList || []
        console.info(repVideoList)
      },
      async queryVideoTerminalList(){
        let resp = (await API.omsAPI[this.env].advert.queryVideoTerminal(
          'video',
          this.token
        )).data; 
        this.terminalTypes = resp.content
      },
      //弹窗
      openEditVideoModal(video = {}){
            this.$refs.editVideoModalForm.resetFields()
            this.editVideoModal = Object.assign(this.editVideoModal,{
                display:true,
                videoTitle:'',
                status:'1',
                displayTerminalId:1,
                sort:1,
                videoUrl:'',
                framePictureUrl:'',
                videoInfo:{},
                videoUpload:0,
                videoCoverUpload:0,
            },video)
            this.$refs.uploadVideo.fileList = []
           
      },
      //删除
      async delVideo(id){
        let post = {}
        post.user = this.editVideoModal.user
        post.videoId = id
        const resp = (await API.omsAPI[this.env].advert.deleteVideo(post, this.token)).data
      
        if(!resp){
          // 失败
          this.$Notice.error({
            title: "删除失败",
            desc: resp.msg
          });
        }else{
          this.$Notice.success({
            title: "删除成功",
          });
          this.queryvideoList()
        }
      },
      // 图片上传前
      async beforeUpload(file) {
          console.info(`${file}`);
          let token = (await API.omsAPI[this.env].common.getUploadToken(
            false,
            this.token
          )).data;
          this.uploadData.form.token = token;
          this.uploadData.name = `${(Date.now() / 1000) | 0}_${file.name}`;
          this.uploadData.form["x:fileDirId"] = 636;
          this.uploadData.form["x:isPrivate"] = 0;
          this.uploadData.form["x:remark"] = "新增视频封面";
          return true;
      },
      uploadVideoCoverProgress(resp){
           let uploadImgPrg = parseInt(resp.percent)
           if(uploadImgPrg <= 99){
              this.editVideoModal.videoCoverUpload = uploadImgPrg
            }
          this.videoLoading = true
      },
      //判断图片格式
      picFormatError(){
          this.$Notice.error({
                title: '只能上传jpg、jpeg、png格式',
          });
      },
      uploadSuccess(resp) {
        this.editVideoModal.videoCoverUrl = resp.materialBase.url;
        this.editVideoModal.videoCoverUpload = 100
        this.videoLoading = false
        // this.editVideoModal.materialId = resp.materialBase.id;
      },
      //视频上传前
      async beforeVideoUpload(file){
          if(file.size > 524288000){
              this.$Notice.error({
                title: '上传视频不能大于500M',
              });
          }
          this.$refs.uploadVideo.fileList = []
          let token = (await API.omsAPI[this.env].common.getUploadToken(
          false,
          this.token
        )).data;

        this.uploadData.form.token = token;
        this.uploadData.name = `${(Date.now() / 1000) | 0}_${file.name}`;   
        this.uploadData.form["x:fileDirId"] = 637;
        this.uploadData.form["x:isPrivate"] = 0;
        this.uploadData.form["x:remark"] = "新增视频";
        return true
      },
      //判断视频格式
      videoFormatError(){
          this.$Notice.error({
                title: '只能上传mp4格式',
          });
      },
      uploadVideoProgress(resp){
          this.editVideoModal.videoUpload = parseInt(resp.percent)
          this.videoLoading = true
          // console.info('progressresp-----------------------------------',resp)
      },
      uploadVideoSuccess(resp){
            let self = this
            this.videoLoading = false
            //然后用文件地址 + vframe/jpg/offset/0 就是取 0秒的截图
            this.editVideoModal.videoUrl = resp.materialBase.url
            this.editVideoModal.framePictureUrl = `${resp.materialBase.url}?vframe/jpg/offset/1`
            
            axios.get(`${resp.materialBase.url}?avinfo`)
                .then(function (response) {
                   self.editVideoModal.videoInfo = Object.assign({}, response.data.format)
                   self.editVideoModal.videoInfo.duration = Math.ceil(self.editVideoModal.videoInfo.duration)
                })
                .catch(function (error) {
                  this.$Notice.error({
                    title: "图片获取失败",
                    desc:error
                  });
                });
            
               
      },
      async addModalOk(){
         let validResult = false 
         let post = {}
         this.modalOkbuttonLoading = true

         this.$refs.editVideoModalForm.validate((valid) => {
             validResult = valid 
          })
          if(this.editVideoModal.videoCoverType === '1' && !this.editVideoModal.videoCoverUrl) {
              this.$Notice.error({
                title: "请选择视频封面图类型",
            });
          }
          // if(!this.editVideoModal.videoCoverUrl || !this.editVideoModal.framePictureUrl ){
          //   this.$Notice.error({
          //       title: "请选择视频封面图类型",
          //   });
          // }
          if(!this.editVideoModal.videoUrl){
            this.$Notice.error({
                title: "请上传视频",
            });
          }
          if(!validResult || (this.editVideoModal.videoCoverType === '1' && !this.editVideoModal.videoCoverUrl) || !this.editVideoModal.videoUrl){
            this.modalOkbuttonLoading = false
            return 
          }
          if(this.editVideoModal.id){
            post.videoId = this.editVideoModal.id
          }
          if(this.editVideoModal.videoCoverType === '1') {
            post.videoCoverUrl = this.editVideoModal.videoCoverUrl
            post.framePictureUrl = ''
          } else {
            post.framePictureUrl = this.editVideoModal.framePictureUrl
            post.videoCoverUrl = ''           
          }
          post.displayTerminalId = this.editVideoModal.displayTerminalId
          post.sort = this.editVideoModal.sort
          post.status = this.editVideoModal.status
          post.user = this.editVideoModal.user
          post.videoCoverType = this.editVideoModal.videoCoverType
          post.videoLength = this.editVideoModal.videoInfo.duration
          post.videoTitle = this.editVideoModal.videoTitle
          post.videoUrl = this.editVideoModal.videoUrl
          if(!this.editVideoModal.id){
              let res = (await API.omsAPI[this.env].advert.updateVideo(
                        post,
                        this.token)
                        ).data
                        if (res.retCode) {
                          this.modalOkbuttonLoading = false
                          this.$Notice.error({
                            title:'添加失败',
                            desc:res.msg
                          })
                        }else{
                          this.editVideoModal.display = false
                          this.modalOkbuttonLoading = false
                          this.queryvideoList()
                        }
          }else{
            let res = (await API.omsAPI[this.env].advert.updateVideo(
                        post,
                        this.token)
                        ).data
                        if (res.retCode) {
                          this.modalOkbuttonLoading = false
                          this.$Notice.error({
                            title:'编辑失败',
                            desc:res.msg
                          })
                        }else{
                          this.editVideoModal.display = false
                          this.modalOkbuttonLoading = false
                          this.editVideoModal.id = ''
                          this.queryvideoList()
                        }
          }
          
      },
      cancelModal(){
        this.editVideoModal.id = ''
        this.editVideoModal.display = false
      },
      secondToDate(result) {
        var h = Math.floor(result / 3600) < 10 ? '0'+Math.floor(result / 3600) : Math.floor(result / 3600);
        var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
        var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
        return result = h + ":" + m + ":" + s;
      },
      preventSubmit(){
          return false
      },
  }
}
</script>

<style lang="scss" scoped>
    .duration{
      position:absolute;
      font-size:16px;
      top:3%;
      left:3%;
      color:#fff;
    }
</style>



// WEBPACK FOOTER //
// src/pages/advert/video-list.vue